// extracted by mini-css-extract-plugin
export default {"container":"StepsTransportator_container__cZB5G","title":"StepsTransportator_title__xDfBK","step":"StepsTransportator_step__f514l","author":"StepsTransportator_author__i1mKB"};